import React from 'react';

type EyebrowTone = 'default' | 'muted' | 'on-dark';

interface EyebrowProps {
  tone?: EyebrowTone;
  as?: keyof JSX.IntrinsicElements;
  className?: string;
  children: React.ReactNode;
}

const TONE_CLASS: Record<EyebrowTone, string> = {
  default: 'text-we-accent-2',
  muted: 'text-we-ink/60',
  'on-dark': 'text-we-bg/55',
};

const Eyebrow: React.FC<EyebrowProps> = ({
  tone = 'default',
  as: Tag = 'span',
  className = '',
  children,
}) => {
  const base = `font-we-mono text-[11px] tracking-[0.18em] uppercase ${TONE_CLASS[tone]}`;
  return <Tag className={`${base} ${className}`.trim()}>{children}</Tag>;
};

export default Eyebrow;
